import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/icon_clean.svg'


const _withScopeId = n => (_pushScopeId("data-v-55d52b4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filterCondition, (tag, index) => {
    return (_openBlock(), _createBlock(_component_a_tag, {
      key: index,
      onClick: ($event: any) => ($setup.handleCloseTag(tag, index))
    }, {
      icon: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(tag.name) + " ", 1)
      ]),
      _: 2
    }, 1032, ["onClick"]))
  }), 128))
}